<template>
  <div class="app-stats relative isolate overflow-hidden">
    <div class="border-b border-b-slate-900/10 lg:border-t lg:border-t-slate-900/5">
      <dl class="mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4 lg:px-2 xl:px-0">
        <div v-for="(stat, statIdx) in items" :key="stat.name" :class="[statIdx % 2 === 1 ? 'sm:border-l' : statIdx === 2 ? 'lg:border-l' : '', 'flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 border-t border-slate-950/5 px-4 py-10 sm:px-6 lg:border-t-0 xl:px-8']">
          <dt class="text-sm font-medium leading-6 text-slate-500">
            <slot name="name">
              {{ stat.name }}
            </slot>
          </dt>
          <dd v-if="stat.change && stat.changeType" :class="[stat.changeType === 'negative' ? 'text-error' : 'text-slate-950', 'text-xs font-medium']">
            <slot name="change">
              <span v-if="stat.changeType === 'positive'" class="i-mdi-arrow-up text-accent" />
              <span v-else class="i-mdi-arrow-down text-error" />
              <span>{{ stat.change }}</span>
            </slot>
          </dd>
          <dd class="w-full flex-none text-xl font-medium leading-10 tracking-tight">
            <slot name="value" :stat="stat">
              <span v-if="typeof stat.value === 'number'">{{ stat.value.toLocaleString() }}</span>
              <span v-else>{{ stat.value }}</span>
            </slot>
          </dd>
        </div>
      </dl>
    </div>

    <div v-if="featured" class="hidden lg:block lg:absolute left-0 top-full -z-10 mt-96 origin-top-left translate-y-40 -rotate-90 transform-gpu opacity-20 blur-3xl sm:left-1/2 sm:-ml-96 sm:-mt-10 sm:translate-y-0 sm:rotate-0 sm:transform-gpu sm:opacity-50" aria-hidden="true">
      <div class="aspect-[1154/678] w-[72.125rem] bg-gradient-to-br from-[#FF80B5] to-[#9089FC]" style="clip-path: polygon(100% 38.5%, 82.6% 100%, 60.2% 37.7%, 52.4% 32.1%, 47.5% 41.8%, 45.2% 65.6%, 27.5% 23.4%, 0.1% 35.3%, 17.9% 0%, 27.7% 23.4%, 76.2% 2.5%, 74.2% 56%, 100% 38.5%)" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'

export type StatItem = {
  label?: string
  name: string
  value: string | number
  change?: string
  changeType?: 'positive' | 'negative'
}

defineProps({
  items: {
    type: Array as PropType<StatItem[]>,
    required: true,
  },
  featured: {
    type: Boolean,
    default: false,
  },
})
</script>
